import React from 'react';
import { Container } from '../../components/layout/Container';
import { PageHeader } from '../../components/layout/PageHeader';
import { CONTACT_INFO } from '../../utils/constants';

export function Privacy() {
  return (
    <div>
      <PageHeader
        title="Gizlilik Sözleşmesi"
        subtitle="TMR Logistics Gizlilik Politikası"
      />

      <Container className="py-5">
        <div className="privacy-content">
          <section className="mb-5">
            <h2 className="mb-4">1. Giriş</h2>
            <p>
              TMR Logistics ("Şirket", "biz", "bizim") olarak, müşterilerimizin gizliliğini korumaya ve uygulanabilir tüm veri koruma yasalarına uygun hareket etmeye kararlıyız. Bu Gizlilik Sözleşmesi, kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklamaktadır.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">2. Toplanan Bilgiler</h2>
            <p>Aşağıdaki türde kişisel bilgileri toplayabiliriz:</p>
            <ul className="mt-3">
              <li><strong>İletişim Bilgileri:</strong> Ad, soyadı, e-posta adresi, telefon numarası</li>
              <li><strong>Şirket Bilgileri:</strong> Şirket adı, vergi numarası, adres</li>
              <li><strong>Kargo Bilgileri:</strong> Gönderici ve alıcı adresleri, kargo içeriği, ağırlık ve boyutlar</li>
              <li><strong>Ödeme Bilgileri:</strong> Fatura ve ödeme yöntemi (kredi kartı, banka transferi vb.)</li>
              <li><strong>Teknik Bilgiler:</strong> IP adresi, tarayıcı türü, ziyaret ettiğiniz sayfalar</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">3. Bilgilerin Kullanımı</h2>
            <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla kullanılır:</p>
            <ul className="mt-3">
              <li>Hizmet taleplerinize cevap vermek ve siparişlerinizi işlemek</li>
              <li>Kargo gönderimi ve teslimatını sağlamak</li>
              <li>Faturalama ve ödeme işlemleri</li>
              <li>Müşteri desteği ve problem çözme</li>
              <li>Hizmetleri iyileştirmek ve yeni hizmetler geliştirmek</li>
              <li>Yasal yükümlülüklere uyum sağlamak</li>
              <li>Dolandırıcılık ve güvenlik tehditlerine karşı koruma</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">4. Bilgi Paylaşımı</h2>
            <p>
              Kişisel verileriniz, hizmet sunabilmek için gerekli olduğunda aşağıdaki taraflarla paylaşılabilir:
            </p>
            <ul className="mt-3">
              <li>Kargo teslimat şirketleri ve lojistik ortakları</li>
              <li>Ödeme işleme hizmetleri sağlayıcıları</li>
              <li>Muhasebe ve vergi danışmanları</li>
              <li>Yasal gereklilikler çerçevesinde hükümet kurumları</li>
            </ul>
            <p className="mt-3">
              Verileriniz, sizin açık rızanız olmaksızın üçüncü taraflara satılmaz veya kiralı olarak verilmez.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">5. Veri Güvenliği</h2>
            <p>
              Kişisel verilerinizi izinsiz erişim, değiştirilme veya yok edilmeden korumak için endüstri standardı güvenlik önlemleri uygulamaktayız:
            </p>
            <ul className="mt-3">
              <li>SSL/TLS şifrelemeleri</li>
              <li>Güvenli veritabanı sistemleri</li>
              <li>Erişim kontrolü ve kimlik doğrulama</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Çalışan gizlilik eğitimi</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">6. Veri Saklama</h2>
            <p>
              Kişisel verileriniz, sözleşmeyi yerine getirmek ve yasal yükümlülüklere uyum sağlamak için gerekli olan süre boyunca saklanır. Kargo işlemi tamamlandıktan sonra verileriniz:
            </p>
            <ul className="mt-3">
              <li>Müşteri hizmetleri için: 2 yıl</li>
              <li>Muhasebe ve vergi amaçları için: 7 yıl (yasal gereklilik)</li>
              <li>İstatistiksel analiz için: 1 yıl (anonim şekilde)</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">7. Sizin Hakları</h2>
            <p>Aşağıdaki KVKK (Kişisel Verileri Koruma Kanunu) haklarına sahipsiniz:</p>
            <ul className="mt-3">
              <li><strong>Bilgi Alma Hakkı:</strong> Hakkınızda tutulan verilerin neler olduğunu öğrenme</li>
              <li><strong>Düzeltme Hakkı:</strong> Hatalı veya eksik bilgileri düzeltme</li>
              <li><strong>Silme Hakkı:</strong> Verilerinizin silinmesini talep etme (koşul dahilinde)</li>
              <li><strong>Sınırlama Hakkı:</strong> Veri işlemenin sınırlandırılmasını isteme</li>
              <li><strong>Taşınabilirlik Hakkı:</strong> Verilerinizin başka bir hizmet sağlayıcıya aktarılmasını isteme</li>
              <li><strong>İtiraz Hakkı:</strong> Veri işlemeye itiraz etme</li>
            </ul>
            <p className="mt-3">
              Bu haklarınızı kullanmak için <strong>tamer.mutlu@tmrlogistic.com</strong> adresine yazılı talep gönderiniz.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">8. Çerezler (Cookies)</h2>
            <p>
              Web sitemiz, kullanıcı deneyimini iyileştirmek için çerezler kullanmaktadır. Çerezler, tarayıcınız tarafından depolanan küçük metin dosyalarıdır. Kullandığımız çerezler:
            </p>
            <ul className="mt-3">
              <li><strong>Zorunlu Çerezler:</strong> Site işlevselliği için gerekli</li>
              <li><strong>Analiz Çerezleri:</strong> Ziyaretçi davranışını anlamak için</li>
              <li><strong>Pazarlama Çerezleri:</strong> Hedefli reklam göstermek için</li>
            </ul>
            <p className="mt-3">
              Çerezleri tarayıcınız ayarlarından devre dışı bırakabilirsiniz.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">9. Üçüncü Taraf Bağlantıları</h2>
            <p>
              Web sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu siteler kendi gizlilik politikalarına sahiptir ve biz bunlardan sorumlu değiliz. Herhangi bir üçüncü taraf sitesini ziyaret etmeden önce gizlilik politikasını okuyunuz.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">10. Gizlilik Politikasında Değişiklikler</h2>
            <p>
              Bu Gizlilik Sözleşmesi zaman zaman güncellenebilir. Önemli değişiklikler durumunda e-posta yoluyla sizi bilgilendireceğiz. Bu sayfayı düzenli aralıklarla kontrol etmeniz önerilir.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">11. İletişim</h2>
            <p>
              Gizlilik politikamız hakkında sorularınız varsa, lütfen bize aşağıdaki yollarla ulaşınız:
            </p>
            <div className="mt-3 p-4 bg-light rounded space-y-2">
              {CONTACT_INFO.map((info, index) => (
                <p key={index} className="flex items-start gap-2">
                  <span className="font-bold min-w-[80px] text-gray-700">
                    {info.href?.startsWith('mailto:') ? 'E-posta' :
                      info.href?.startsWith('tel:') ? 'Telefon' :
                        'Adres'}:
                  </span>
                  {info.type === 'link' ? (
                    <a href={info.href} className="text-primary hover:underline">{info.content}</a>
                  ) : (
                    <span>{info.content}</span>
                  )}
                </p>
              ))}
            </div>
          </section>

          <section className="mb-5">
            <h2 className="mb-4">12. KVKK Veri Sorumlusu</h2>
            <p>
              <strong>Veri Sorumlusu:</strong> TMR Logistics A.Ş.
            </p>
            <p>
              Veri Koruma Kurumu'na yapılan şikayetler için:
              <a href="https://www.kvk.gov.tr" target="_blank" rel="noopener noreferrer">
                Veri Koruma Kurumu (VKK)
              </a>
            </p>
          </section>

          <div className="alert alert-info mt-5">
            <p className="mb-0">
              <strong>Son Güncelleme:</strong> 29 Aralık 2025
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}
